<template>
<!-- FINAL MEMBER -->
  <div class="wrapper">
    <div>
    <div class="card">
      <div class="card-body">
        <CRow>
          <CCol sm="5" lg="12" >
              
             <CRow >              
              <CCol  sm="5" lg="3" >
                <label class="mt-2"  > Tanggal User Input </label>
                 <CInput  v-model="date_start_created" type="date" />
                 <CInput  v-model="date_end_created" type="date" />
              </CCol>
              <CCol  sm="5" lg="3" >
                <label class="mt-2"  > Tanggal Kunjungan Pertama ke Gereja </label>
                 <CInput  v-model="date_start" type="date" />
                 <CInput  v-model="date_end" type="date" />
              </CCol>
              <CCol  sm="5" lg="3" >
                <label class="mt-2"  > Keperluan </label> 
              <b-form-select v-model="keperluan_id" :options="options_keperluan"></b-form-select>
              </CCol>
              <CCol  sm="5" lg="3" >
                <label  class="mt-2" > Service </label> 
              <b-form-select v-model="servicetype" :options="options_service"></b-form-select>
               <CButton class="col-5 mt-3"  variant="outline" color="info" @click="filter()">Search</CButton>
              </CCol>
              
            </CRow>
            
             
          </CCol>
        </CRow>
     
    </div>
    </div>
    <CRow class="mt-3">
      <div>
      </div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            :is_uuid="true"
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @search="handleSearch"
                            :btn_show="false"
                            :btn_edit="false"
                            :btn_deactivate="false"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        
                           />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <alertmodal></alertmodal>
  </div>
  </div>  
</template>

<script>
import Datatable from '@/components/datatables_newcomer_report.vue' 
import axios from 'axios';
import EventBus from '@/eventBus';

import report from '@/services/report';
import member from '@/services/member';
import newcomer from '@/services/newcomer';
import service from '@/services/service';
import keperluan from '@/services/keperluan';

import alertmodal from '@/views/alert/modal.vue';
import Multiselect from 'vue-multiselect'

import moment from 'moment';

const token = localStorage.getItem('token');

export default {
  name: 'MemberTables',
  components: { Datatable, alertmodal,Multiselect },
  data () {
    return {
      form:{
        firstname:'',
        lastname:'',
        email:'',
        dob:''
      },
      updateSubmit: false,
      fields: [
          {key: 'name', sortable: false, },
          {key: 'email', sortable: false},
          {key: 'dob', sortable: false},
          {key: 'phone', sortable: false},
          {key: 'location', sortable: false},
          {key: 'created_at', label: 'Date Submit', sortable: false}, 
          {key: 'service_date', sortable: false},         
          {key: 'service_type', sortable: false},
      ],
      items: [],
      options_newcomer:[],
      options_service:[],
      options_keperluan: [], 
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      date_start: '',
      date_end: '',
      date_start_created: '',
      date_end_created: '',
      servicetype: '',
      keperluan_id: ''
    }
   },
    created() {
      //options keperluan
      this.options_keperluan.push({text: '', value:''})
      keperluan.getKeperluan()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options_keperluan.push({text: res.data[i].name, value:res.data[i].id})
        }
      }).catch((er) =>{
      })

      //options service
      this.options_service.push({text: '', value:''})
      service.getService()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options_service.push({text: res.data[i].name, value:res.data[i].name})
        }
      }).catch((er) =>{
      })
  },

   mounted (){
     this.loadData()

      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
    openModal: function () {
      var params = {title: 'Add New Member', mode:'create'}
      EventBus.$emit('OPEN_MODAL_MEMBER', params)
    },
    openShow: function(uuid){
      member.getMemberbyID(uuid)
      .then(res => {
      var params = {title: 'Detail member', mode:'detail', data:res.data}
      EventBus.$emit('OPEN_DETAIL_MEMBER', params)
      console.log('OPEN_DETAIL_MEMBER')
      })   
      this.$router.push({name:'member_detail',query: {Pud:uuid} }) 
    },

    openModalEdit(id){
        var params = {title: 'Edit Member', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_MEMBER', params)
    },

    deactivate(id){
      if(confirm("Do you really want to deactivate?")){
        member.deactivateMember(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },

    reactivate(id){
      if(confirm("Do you really want to reactivate?")){
        member.reactivateMember(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
    },

     loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        date_start: this.date_start,
        date_end: this.date_end,
        date_start_created: this.date_start_created,
        date_end_created: this.date_end_created,
        keperluan_id: this.keperluan_id,
        servicetype: this.servicetype,
      }
      report.getNewComerReport(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    filter(){

      if( this.date_start != '' ){this.date_start = moment(this.date_start).format ('DD/MM/YYYY');} 
      if( this.date_end != '' ){this.date_end = moment(this.date_end).format ('DD/MM/YYYY');} 
      if( this.date_start_created != '' ){this.date_start_created = moment(this.date_start_created).format ('DD/MM/YYYY');} 
      if( this.date_end_created != '' ){this.date_end_created = moment(this.date_end_created).format ('DD/MM/YYYY');} 

      this.loadData()
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
   handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },
    handleGrantWebAccess(val) {
      if(confirm("Do you really want to grant web access?")){
        member.grantwebaccess(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }   
    },
    handleResetPassword(val) {
      if(confirm("Do you really want to reset password?")){
        member.resetpassword(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }       
    },    

  }
  
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
